import React, { Component } from 'react'

import bgImage from '../../assets/img/bg.jpg'
import logoImage from '../../assets/img/logo.png'
import ztImage from '../../assets/img/zt.png'

import { TopWrapper } from './style'

export default class Top extends Component {
    render() {
        return (
            <TopWrapper bgImage={bgImage}>
                <img className="logo" src={logoImage} alt="" />
                <img className="zt" src={ztImage} alt="" />
            </TopWrapper>
        )
    }
}
